import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", { d: "M11.115 12.884a.75.75 0 0 1 0 1.061l-2.829 2.829a.75.75 0 0 1-1.06-1.061l2.828-2.829a.75.75 0 0 1 1.06 0Z" }, null, -1), a = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M20.484.687a1 1 0 0 0-1.414 0L2.806 16.95a1 1 0 0 0 0 1.415l.884.883-2.122 2.122a.75.75 0 1 0 1.061 1.06l2.122-2.121.884.884a1 1 0 0 0 1.414 0L23.312 4.929a1 1 0 0 0 0-1.414L20.484.687Zm-3.005 3.712-4.597 4.596 2.122 2.122L19.6 6.52 17.48 4.4ZM4.22 17.657l7.602-7.6 2.121 2.12-7.601 7.602-2.122-2.122ZM18.54 3.338l2.12 2.122 1.238-1.238-2.121-2.12-1.238 1.236Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  n,
  a
];
function c(r, s) {
  return t(), l("svg", o, [...d]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
